import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=6977e3d3&scoped=true"
import script from "./ClientHeader.vue?vue&type=script&lang=js"
export * from "./ClientHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6977e3d3",
  null
  
)

export default component.exports